<template>
  <ResultForm :data="data" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"

import ResultForm from "./ResultForm.vue"

//import moment from "moment"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      resultData: null,
      lotto: {
        lotto_type: this.$route.params.lottoType,
        lotto_date: '',
        lotto_id: null,
        start_spin: '',
        show_1st: '',
        show_2nd: '',
        results: {
          prize_1st: '',
          prize_2nd: '',
          prize_3rd_1: '',
          prize_3rd_2: '',
          prize_3rd_3: '',
          prize_3rd_4: '',
          prize_3rd_5: '',
          prize_3rd_6: '',
          prize_3rd_7: '',
          prize_3rd_8: '',
        }
      }
    }
  },
  computed: {
    data() {
      return this.lotto
    }
  },
  methods: {
    loadResult() {
      LottoService.getResult(this.$route.params.lottoType, this.$route.params.resultId).then((response) => {
        if (response.status === 'success') {
          this.resultData = response.data
          this.lotto.lotto_type = this.resultData.lotto_type
          this.lotto.lotto_date = this.resultData.lotto_date
          this.lotto.lotto_id = this.resultData.lotto_id
          this.lotto.start_spin = this.resultData.start_spin
          this.lotto.show_1st = this.resultData.show_1st
          this.lotto.show_2nd = this.resultData.show_2nd
          this.lotto.results = this.resultData.results
        } else {
          this.$router.push({ name: 'admin-results' })
        }
      })
    },
    save(data) {
      LottoService.updateResult(this.$route.params.lottoType, this.$route.params.resultId, data).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-lotto-results', params: { lottoType: data.lotto_type } })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  },
  created() {
    this.loadResult()
  }
}

</script>
